import { Subject } from "rxjs";
import { createAPIProxy, OnRequestHandler } from "./APIProxy";
import { RenderAPI } from "./APIProxy.render.d";

// Create request processor cache
type RequestProcessorCache = Record<string, OnRequestHandler<any[]>>;
const requestProcessorCache: RequestProcessorCache = {};

// Create the proxy instance
const RenderApiServer = createAPIProxy(function (
  api,
  args,
  callingFunctionName
) {
  // console.log("[Server.customCallingFunction] API:", api, "Args:", args);
  switch (callingFunctionName) {
    case "onRequest": {
      const processor = args[0];
      if (processor && typeof processor === "function") {
        requestProcessorCache[api.join(".")] = args[0];
      } else {
        console.error(
          `[Error] register API Sever processor error for ${JSON.stringify(
            api
          )}, handler is not a function.`
        );
      }
      break;
    }
    case "sendEvent":
      window.parent.postMessage({
        eventName: args[0],
        message: {
          data: args[1],
          meta: {
            api,
            args,
          },
        },
      });
      break;
    default:
      break;
  }
});

// export API server
export const renderApiServer = RenderApiServer as unknown as RenderAPI;

// example
// figmaApi.dev.getTime.call();

// handle message
window.addEventListener("message", async (_message) => {
  console.log("# render.server", _message);
  const { id, message = {} } = _message.data;
  const api: string[] = message.api;
  const args: any[] = message.args;
  if (!api || !args) {
    console.log("[Skip] API Server process, original message:", _message);
    return;
  }

  const apiName = api.join(".");
  if (!requestProcessorCache[apiName]) {
    console.warn(
      `[Warning] There is no handler registered for API: ${apiName}`
    );
    return;
  }

  const result = await requestProcessorCache[apiName].apply(null, args);
  console.log(
    "#### window.postMessage",
    window.postMessage,
    window.parent.postMessage
  );
  window.parent.postMessage(
    {
      id,
      message: {
        result,
        meta: {
          api,
          args,
        },
      },
    },
    "*"
  );
});

export const fovSub = new Subject<number>();

renderApiServer.render.updateFOV.onRequest((fov) => {
  console.log("#renderApiServer.render.updateFOV.onRequest");
  fovSub.next(fov);
});

export const rotateSub = new Subject<{ x: number; y: number; z: number }>();
renderApiServer.render.setRotateValue.onRequest((rotateValues) => {
  rotateSub.next(rotateValues);
});

export const backgroundColorSub = new Subject<string>();
renderApiServer.render.updateBackgroundColor.onRequest((color) => {
  backgroundColorSub.next(color);
});
